export { default } from './ManageTable';
